import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";

export default function FAQ({ t }) {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-stone-base" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="text-amber-500 text-xs uppercase tracking-[0.3em] mb-4">{t.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-50 leading-tight">{t.title}</h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {t.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-stone-800 rounded-xl px-6 bg-stone-900/40 data-[state=open]:border-amber-600/40 data-[state=open]:bg-stone-900"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-stone-100 hover:no-underline text-left text-base md:text-lg font-medium font-serif py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone-300 leading-relaxed text-base pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
